// Paletas de color prediseñadas (global por cuenta). El color "brand" recolorea
// toda la marca (navy) incluyendo botones; "light" es el tono de acento/hover.
export const PALETTES = [
  { id: "marino", name: "Marino", brand: "#112240", light: "#1E3A8A", ink: "#0A1428" },
  { id: "zavia", name: "ZAVIA", brand: "#0A6CF0", light: "#0A84FF", ink: "#0047C2" },
  { id: "negro", name: "Negro y blanco", brand: "#111111", light: "#3A3A3A", ink: "#000000" },
  { id: "blanco", name: "Blanco y negro", brand: "#FFFFFF", light: "#E5E7EB", ink: "#111827" },
  { id: "rojoblanco", name: "Rojo y blanco", brand: "#DC2626", light: "#F87171", ink: "#7F1D1D" },
  { id: "oceano", name: "Océano", brand: "#0E3A5F", light: "#2563EB", ink: "#082438" },
  { id: "cielo", name: "Cielo", brand: "#075985", light: "#0EA5E9", ink: "#053B58" },
  { id: "esmeralda", name: "Esmeralda", brand: "#064E3B", light: "#059669", ink: "#032D22" },
  { id: "bosque", name: "Bosque", brand: "#14532D", light: "#16A34A", ink: "#0C3018" },
  { id: "turquesa", name: "Turquesa", brand: "#134E4A", light: "#0D9488", ink: "#0B302E" },
  { id: "indigo", name: "Índigo", brand: "#312E81", light: "#4F46E5", ink: "#1E1B4B" },
  { id: "uva", name: "Uva", brand: "#4C1D95", light: "#7C3AED", ink: "#2E1065" },
  { id: "rosa", name: "Rosa", brand: "#831843", light: "#DB2777", ink: "#500C28" },
  { id: "vino", name: "Vino", brand: "#7F1D1D", light: "#DC2626", ink: "#4C0F0F" },
  { id: "cobre", name: "Cobre", brand: "#7C2D12", light: "#EA580C", ink: "#4A1608" },
  { id: "ambar", name: "Ámbar", brand: "#78350F", light: "#D97706", ink: "#451F08" },
  { id: "grafito", name: "Grafito", brand: "#1F2937", light: "#4B5563", ink: "#111827" },
  { id: "acero", name: "Acero", brand: "#0F172A", light: "#334155", ink: "#020617" },
];

export const BUTTON_SHAPES = [
  { id: "rounded", name: "Redondeado" },
  { id: "pill", name: "Pastilla" },
  { id: "square", name: "Recto" },
];

// Opciones de color de texto (para títulos, textos del sistema y texto de botones).
export const TEXT_COLORS = [
  { id: "auto", name: "Automático", hex: null },
  { id: "blanco", name: "Blanco", hex: "#FFFFFF" },
  { id: "negro", name: "Negro", hex: "#111111" },
  { id: "marino", name: "Marino", hex: "#112240" },
  { id: "pizarra", name: "Pizarra", hex: "#475569" },
  { id: "gris", name: "Gris", hex: "#6B7280" },
  { id: "azul", name: "Azul", hex: "#2563EB" },
  { id: "esmeralda", name: "Esmeralda", hex: "#059669" },
  { id: "vino", name: "Vino", hex: "#DC2626" },
  { id: "dorado", name: "Dorado", hex: "#B45309" },
];

// Colores de paneles/tarjetas (tonos claros para mantener legibilidad del texto).
export const PANEL_COLORS = [
  { id: "auto", name: "Blanco", hex: null },
  { id: "marfil", name: "Marfil", hex: "#FAF7F0" },
  { id: "perla", name: "Gris perla", hex: "#F1F3F6" },
  { id: "cielo", name: "Azul cielo", hex: "#EFF6FF" },
  { id: "menta", name: "Menta", hex: "#F0FDF4" },
  { id: "lavanda", name: "Lavanda", hex: "#F5F3FF" },
  { id: "rosa", name: "Rosa", hex: "#FDF2F8" },
  { id: "arena", name: "Arena", hex: "#FBF6EC" },
];

export const DEFAULT_PALETTE = "marino";
export const DEFAULT_BTN = "rounded";

export function getPanelColor(id) {
  return PANEL_COLORS.find((c) => c.id === id) || PANEL_COLORS[0];
}

export function getPalette(id) {
  return PALETTES.find((p) => p.id === id) || PALETTES.find((p) => p.id === DEFAULT_PALETTE);
}
export function getTextColor(id) {
  return TEXT_COLORS.find((c) => c.id === id) || TEXT_COLORS[0];
}

function hexToRgb(hex) {
  const h = hex.replace("#", "");
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
}
export function hexToRgbTriplet(hex) {
  const [r, g, b] = hexToRgb(hex);
  return `${r} ${g} ${b}`;
}
export function luminance(hex) {
  const [r, g, b] = hexToRgb(hex).map((v) => v / 255);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
export function hexToHsl(hex) {
  let [r, g, b] = hexToRgb(hex).map((v) => v / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

function shade(hex, pct) {
  // pct>0 aclara, pct<0 oscurece
  const [r, g, b] = hexToRgb(hex);
  const f = (c) => {
    const v = pct >= 0 ? c + (255 - c) * pct : c * (1 + pct);
    return Math.max(0, Math.min(255, Math.round(v)));
  };
  const to2 = (n) => n.toString(16).padStart(2, "0");
  return `#${to2(f(r))}${to2(f(g))}${to2(f(b))}`;
}
export function paletteFromHex(hex) {
  return { brand: hex, light: shade(hex, 0.22), ink: shade(hex, -0.28) };
}

export function applyTheme(paletteId, shape, textColors, logoColors, panelColor, customColor) {
  const root = document.documentElement;
  const p = (paletteId === "custom" && customColor)
    ? paletteFromHex(customColor)
    : (paletteId === "logo" && logoColors && logoColors.brand)
      ? { brand: logoColors.brand, light: logoColors.light || logoColors.brand, ink: logoColors.ink || logoColors.brand }
      : getPalette(paletteId);
  root.style.setProperty("--brand-rgb", hexToRgbTriplet(p.brand));
  root.style.setProperty("--brand-light-rgb", hexToRgbTriplet(p.light));
  root.style.setProperty("--brand-ink-rgb", hexToRgbTriplet(p.ink));
  root.style.setProperty("--primary", hexToHsl(p.brand));
  root.style.setProperty("--ring", hexToHsl(p.brand));
  root.style.setProperty("--accent", hexToHsl(p.light));
  root.setAttribute("data-btn-shape", BUTTON_SHAPES.some((s) => s.id === shape) ? shape : DEFAULT_BTN);

  // Auto-contraste: si la marca es muy clara, forzamos texto oscuro y borde en botones
  const isLight = luminance(p.brand) > 0.7;
  if (isLight) {
    root.setAttribute("data-brand-light", "on");
    // Tono oscuro legible para textos/bordes de marca (botones outline/secundarios) sobre paneles claros.
    const inkHex = p.ink || "#111827";
    const contrastHex = luminance(inkHex) < 0.45 ? inkHex : "#111827";
    root.style.setProperty("--brand-contrast-rgb", hexToRgbTriplet(contrastHex));
  } else {
    root.removeAttribute("data-brand-light");
    root.style.removeProperty("--brand-contrast-rgb");
  }

  const tc = textColors || {};
  const autoDark = "#111827";
  const applyTC = (id, cssVar, attr) => {
    const c = getTextColor(id);
    if (c && c.hex) { root.style.setProperty(cssVar, c.hex); root.setAttribute(attr, "on"); }
    else if (isLight) { root.style.setProperty(cssVar, autoDark); root.setAttribute(attr, "on"); } // marca clara -> texto oscuro auto
    else { root.style.removeProperty(cssVar); root.removeAttribute(attr); }
  };
  applyTC(tc.title, "--text-title", "data-title-color");
  applyTC(tc.body, "--text-body", "data-text-color");
  applyTC(tc.btn, "--btn-text", "data-btntext-color");

  // Color de paneles/tarjetas
  const pc = getPanelColor(panelColor);
  if (pc && pc.hex) { root.style.setProperty("--panel", pc.hex); root.setAttribute("data-panel-color", "on"); }
  else { root.style.removeProperty("--panel"); root.removeAttribute("data-panel-color"); }
}

// Restablece TODO al stock de ZAVIA (usado por el panel del creador y el botón Restablecer).
export function resetThemeToStock() {
  const root = document.documentElement;
  ["--brand-rgb", "--brand-light-rgb", "--brand-ink-rgb", "--brand-contrast-rgb", "--primary", "--ring", "--accent", "--text-title", "--text-body", "--btn-text", "--panel"].forEach((v) => root.style.removeProperty(v));
  ["data-brand-light", "data-title-color", "data-text-color", "data-btntext-color", "data-panel-color"].forEach((a) => root.removeAttribute(a));
  root.setAttribute("data-btn-shape", DEFAULT_BTN);
}
